import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import { FormBuilder } from '@angular/forms';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-add-modal-list',
  // standalone: true,
  // imports: [],
  templateUrl: './add-modal-list.component.html',
  styleUrl: './add-modal-list.component.scss'
})
export class AddModalListComponent implements OnInit {

  PendingAdd: any;
    start_date: any;
    end_date: any;
  
  
    constructor(private dialogRef: MatDialogRef<AddModalListComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private service: DigisubservicesService,
      private cdr: ChangeDetectorRef,private fb: FormBuilder
    )
     { }
  rep_name:any
  district:any
  taluka:any;
  delivery_mode:any
  sub_type:any
  state:any
  country:any
  prant_name:any
  repDataList: any[] = [];
  selectedFields: string[] = [];
  pincode:any
  officer: any
  disrepname: any

  
    ngOnInit(): void {
  
      this.rep_name= this.data['rep_name']
          this.district= this.data['district_name']
          this.taluka= this.data['taluka_name']
          this.delivery_mode= this.data['delivery_mode']
          this.start_date = this.data['start_date']
          this.end_date = this.data['end_date']
          this.sub_type = this.data['sub_type']
          this.state = this.data['state']
          this.country = this.data['country']
          this.prant_name = this.data['prant_name']
          this.pincode= this.data['pincode']
          this.officer = this.data['officer']
          this.disrepname = this.data['disrepname']

      const selectedYear = sessionStorage.getItem('selectedYear') || '';

      const years = selectedYear.match(/\d{4}/g);

      let loginFY = '';

      if (years && years.length >= 2) {
        loginFY = `${years[0].slice(-2)}-${years[1].slice(-2)}`;
      }
  
          const req:any = {
      
            "fy":loginFY,
            "delivery_mode":this.delivery_mode,
            "district":this.district,
            "taluka":this.taluka,
            "rep_name":this.rep_name,
            "start_date" : this.start_date,
            "end_date" : this.end_date,
            "country":this.country,
            "state":this.state,
            "prant_name":this.prant_name,
            "sub_type":this.sub_type,
            "pincode":this.pincode,
            "officer":this.officer,
            "disrepname":this.disrepname,
        
          }
  
          console.log("req for add", req)
  
      this.rep_name = this.data?.rep_name || '';
      this.district = this.data?.district_name || '';
      this.taluka = this.data?.taluka_name || '';
      this.state = this.data?.state || '';
      this.country = this.data?.country || '';
      this.prant_name = this.data?.prant_name || '';
      this.sub_type = this.data?.sub_type || '';
      this.delivery_mode = this.data?.delivery_mode || '';
          
      this.service.getgetpendingAdd(req).subscribe((data: any) => {
        console.log("pending add=", data);
        //  this.PendingAdd = (data as any);;

        if (Array.isArray(data) && data[0]?.rep_data?.length) {
          this.repDataList = data.flatMap(item => item.rep_data || []);
        } else {
          this.repDataList = [];
        }

      });


          
    }

    show=false 
//Old Correct Code 
//   printPage() {
//     this.show = true;
//     const printContent = document.getElementById('print-section')?.outerHTML;
//     if (!printContent) {
//       console.error("Print section not found!");
//       return;
//     }

//     const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

//     if (printWindow) {
//       printWindow.document.open();
//       printWindow.document.write(`
//         <html>
//           <head>
//             <title>Print Report</title>
//            <style>
// @media print {
//   @page {
//     size: A3 landscape;
//     margin: 5mm;
//   }

//   html, body {
//     margin: 0;
//     padding: 0;
//     font-family: Arial, sans-serif;
//     font-size: 15px;
//     line-height: 1.2;
//     height: 100%;
//   }

//   table {
//     width: 100%;
//     min-height: 100%;
//     border-collapse: collapse;
//     table-layout: fixed;
//   }

//   tr {
//     page-break-inside: avoid;
//   }

//   th, td {
//     padding: 1px;
//     border: 1px solid black;
//     text-align: center;
//     font-size: 14px;
//     line-height: 1.2;
//     box-sizing: border-box;
//   }

//   .noPrint {
//     display: none;
//   }
// }
// </style>

//           </head>
//           <body>
//             <div id="print-section">
//               ${printContent}
//             </div>
//             <script>
//               window.onload = function() {
//                 window.print();
//                 setTimeout(() => { window.close(); }, 500);
//               };
//             </script>
//           </body>
//         </html>
//       `);
//       printWindow.document.close();
//     } else {
//       console.error("Failed to open print window.");
//     }
//   }

//New Less Data Correct Code
 printPage() {
    this.show = true;
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Print Report</title>
           <style>
@media print {
  @page {
    size: A3 landscape;
    margin: 5mm;
  }

  html, body {
    margin: 0;
    padding: 0;
    font-family: Arial, sans-serif;
    font-size: 15px;
    line-height: normal;
 
  }

  table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
  }

  tr {
    page-break-inside: avoid;
  }

  th, td {
    padding: 1px;
    border: 1px solid black;
    text-align: center;
    font-size: 14px;
    line-height: normal;
    box-sizing: border-box;
  }

  .noPrint {
    display: none;
  }
}
</style>

          </head>
          <body>
            <div id="print-section">
              ${printContent}
            </div>
            <script>
              window.onload = function() {
                window.print();
                setTimeout(() => { window.close(); }, 500);
              };
            </script>
          </body>
        </html>
      `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }
  

   exportExcel(fileName): void {
      /* table id is passed over here */
      let element = document.getElementById('print-section');
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  
      /* generate workbook and add the worksheet */
      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  
      /* save to file */
      XLSX.writeFile(wb, fileName + '.xlsx');
    }

}
